(function (global) {
  'use strict';
  if (global.CPProductTools) return;

  function number(value) {
    var parsed = Number(String(value == null ? '' : value).replace(',', '.'));
    return Number.isFinite(parsed) ? parsed : 0;
  }
  function money(cents) {
    var currency = global.Shopify && global.Shopify.currency && global.Shopify.currency.active || 'GBP';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: currency }).format(cents / 100); }
    catch (_) { return currency + ' ' + (cents / 100).toFixed(2); }
  }
  function basePack(size, unit) {
    size = number(size); unit = String(unit || '').toLowerCase().trim();
    if (size <= 0) return { value: 0, unit: '' };
    if (unit === 'kg') return { value: size * 1000, unit: 'g' };
    if (unit === 'g' || unit === 'ml') return { value: size, unit: unit };
    if (['l', 'litre', 'litres'].indexOf(unit) !== -1) return { value: size * 1000, unit: 'ml' };
    if (['bag', 'bags', 'count', 'each'].indexOf(unit) !== -1) return { value: size, unit: 'bag' };
    return { value: 0, unit: '' };
  }
  function titlePack(title) {
    var match = String(title || '').match(/(?:^|\s|[-–—(/])(?:(\d+)\s*[x×]\s*)?(\d+(?:[.,]\d+)?)\s*(kg|g|ml|l)(?=\s|$|[-–—)/])/i);
    return match ? basePack(number(match[2]) * (number(match[1]) || 1), match[3]) : { value: 0, unit: '' };
  }
  function normaliseQuantity(value, input) {
    var min = Math.max(1, Math.ceil(number(input && input.min) || 1));
    var step = Math.max(1, Math.ceil(number(input && input.step) || 1));
    var max = number(input && input.max);
    if (max > 0 && max < min) return null;
    var result = min + Math.ceil(Math.max(0, number(value) - min) / step) * step;
    if (max > 0 && result > max) result = min + Math.floor((max - min) / step) * step;
    return Number.isSafeInteger(result) && result >= min ? result : null;
  }
  function memoryProduct(root) {
    var section = root.closest('[data-cp-product]');
    var select = section && section.querySelector('form.cp-product__form [name="id"]');
    var variant = select && select.value || root.dataset.variant;
    var url = root.dataset.url;
    try { var parsed = new URL(url, location.origin); if (variant) parsed.searchParams.set('variant', variant); var plan = section && section.querySelector('[name="selling_plan"]'); if (plan && !plan.disabled && plan.value) parsed.searchParams.set('selling_plan', plan.value); else parsed.searchParams.delete('selling_plan'); url = parsed.pathname + parsed.search; } catch (_) {}
    return { handle: root.dataset.handle, title: root.dataset.title, url: url,
      price: root.dataset.price, image: root.dataset.image || '', imageAlt: root.dataset.title,
      variant: number(variant) || null, available: root.dataset.available === 'true' };
  }
  function initMemory(root) {
    var memory = global.CPStorefrontMemory;
    if (!root || root.dataset.cpMemoryReady === '1' || !memory) return;
    root.dataset.cpMemoryReady = '1';
    memory.recordView(memoryProduct(root));
    var button = root.querySelector('[data-cp-consumer-save]');
    if (!button) return;
    function isSaved(product) { return memory.saved().some(function (item) { return item.handle === product.handle && String(item.variant) === String(product.variant); }); }
    function paint() {
      var saved = isSaved(memoryProduct(root));
      button.classList.toggle('is-saved', saved); button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      button.textContent = saved ? 'Saved on this device ✓' : 'Save for later';
    }
    button.addEventListener('click', function () {
      var product = memoryProduct(root); var saved = isSaved(product);
      if (saved) memory.removeSaved(product.handle); else memory.saveProduct(product);
      paint();
      if (global.CPAnalytics) global.CPAnalytics.track('cp_b2c_product_save', { handle: product.handle, variant_id: product.variant, saved: !saved, storage: memory.isPersistent() ? 'device' : 'session' });
    });
    var section = root.closest('[data-cp-product]');
    if (section) section.addEventListener('cp:variant:change', paint);
    document.addEventListener('cp:memory:change', function () { if (root.isConnected) paint(); });
    paint();
  }
  function plannerDefaults(root) {
    if (!root.cpPlannerDefaults) root.cpPlannerDefaults = { packSize: root.dataset.packSize, packUnit: root.dataset.packUnit,
      servings: root.dataset.servings, dose: root.dataset.dose, doseUnit: root.dataset.doseUnit, title: root.dataset.productTitle };
    return root.cpPlannerDefaults;
  }
  function syncVariant(section, variant, priceCents) {
    section.querySelectorAll('[data-cp-replenishment]').forEach(function (root) {
      var defaults = plannerDefaults(root);
      var originalPack = basePack(defaults.packSize, defaults.packUnit);
      if (!originalPack.value) originalPack = titlePack(defaults.title);
      var pack = basePack(variant.packSize, variant.packUnit || defaults.packUnit);
      if (!pack.value) pack = titlePack(variant.title);
      var ambiguousCount = /\d+\s*(?:bags?|packs?|sachets?|units?)\b/i.test(String(variant.title || ''));
      if (!pack.value && !ambiguousCount) pack = originalPack;
      root.dataset.packSize = String(pack.value); root.dataset.packUnit = pack.unit;
      root.dataset.packResolved = 'true';
      var samePack = pack.value === originalPack.value && pack.unit === originalPack.unit;
      root.dataset.servings = String(number(variant.servings) || (samePack ? number(defaults.servings) : 0));
      root.dataset.priceCents = String(priceCents);
      var dose = root.querySelector('[name="dose"]');
      if (dose && !dose.dataset.cpEdited) dose.value = number(variant.dose) || number(defaults.dose) || '';
      var unit = String(variant.doseUnit || defaults.doseUnit || pack.unit || '');
      root.dataset.doseUnit = unit;
      var label = root.querySelector('[data-cp-dose-unit]'); if (label) label.textContent = unit ? '(' + unit + ')' : '';
      if (root.cpCalculate) root.cpCalculate();
    });
  }
  function initPlanner(root) {
    if (!root || root.dataset.cpPlannerReady === '1') return;
    var fields = root.querySelector('[data-cp-plan-form]');
    var output = root.querySelector('[data-cp-plan-output]');
    var apply = root.querySelector('[data-cp-apply-quantity]');
    if (!fields || !output || !apply) return;
    root.dataset.cpPlannerReady = '1'; plannerDefaults(root);
    var result = null;
    function field(name) { return fields.querySelector('[name="' + name + '"]'); }
    function calculate() {
      var people = number(field('people') && field('people').value);
      var drinks = number(field('drinks') && field('drinks').value);
      var days = number(field('days') && field('days').value);
      var dose = number(field('dose') && field('dose').value);
      var pack = basePack(root.dataset.packSize, root.dataset.packUnit);
      if (!pack.value && root.dataset.packResolved !== 'true') pack = titlePack(root.dataset.productTitle);
      var unit = String(root.dataset.doseUnit || pack.unit);
      var servings = pack.value > 0 && dose > 0 && (!unit || unit === pack.unit) ? pack.value / dose : number(root.dataset.servings);
      var validFields = Array.prototype.every.call(fields.querySelectorAll('input'), function (input) { return input.validity.valid; });
      if (!validFields || people <= 0 || drinks <= 0 || days <= 0 || days > 7 || servings <= 0) {
        result = null; apply.hidden = true;
        output.innerHTML = '<strong>Check the pack size and dose</strong><span>Enter valid usage values and use the amount from the current pack, recipe or machine setup. A verified pack size or servings per pack is needed before we suggest a quantity.</span>';
        return;
      }
      var weeklyDrinks = people * drinks * days;
      var fourWeekDrinks = weeklyDrinks * 4;
      var wanted = Math.max(1, Math.ceil(fourWeekDrinks / servings));
      var section = root.closest('[data-cp-product]');
      var quantityInput = section && section.querySelector('form.cp-product__form [name="quantity"]');
      var recommended = normaliseQuantity(wanted, quantityInput);
      if(recommended===null||recommended<wanted){window.CPEnquiry?.present({id:'product-usage',source:'Product repeat-order planner',type:'ingredients',summary:'Product: '+root.dataset.productTitle+'\nPeople: '+people+'\nDrinks per person/day: '+drinks+'\nDays/week: '+days+'\nDose: '+dose+' '+unit+'\nEstimated four-week drinks: '+Math.round(fourWeekDrinks)+'\nRequired packs: '+wanted+'\nOnline limit does not cover the requirement.',products:[{title:root.dataset.productTitle,url:location.href,quantity:wanted}]},root);}
      if (recommended === null) { result = null; apply.hidden = true; output.textContent = 'This quantity is not available online. Please check the product options or contact us.'; return; }
      var durationDays = servings / Math.max(weeklyDrinks / 7, 0.1);
      var price = number(root.dataset.priceCents);
      var duration = durationDays < 14 ? 'about ' + Math.max(1, Math.round(durationDays)) + ' days' : 'about ' + Math.max(2, Math.round(durationDays / 7)) + ' weeks';
      var rulesNote = recommended > wanted ? ' The product’s minimum or pack multiple increases the order to ' + recommended + '.' : '';
      if (recommended < wanted) rulesNote = ' Four weeks needs roughly ' + wanted + ' packs, but the online maximum allows ' + recommended + '. This will not cover the full period; contact us for a larger order.';
      result = { quantity: recommended, drinks: Math.round(fourWeekDrinks) };
      output.innerHTML = '<strong>' + (recommended < wanted ? 'Online quantity: ' : 'Plan on roughly ') + recommended + ' pack' + (recommended === 1 ? '' : 's') + (recommended < wanted ? '' : ' for four weeks') + '</strong><span>That is about ' + Math.round(fourWeekDrinks) + ' drinks. One pack should last ' + duration + '.' + (price > 0 ? ' At the selected price, the product total is ' + money(price * recommended) + '.' : '') + rulesNote + ' Allow for changes in dose, waste and usage. Shipping and any checkout adjustments are not included.</span>';
      var add = section && section.querySelector('[data-cp-add-button]');
      apply.hidden = !quantityInput || !add || add.disabled;
      apply.textContent = 'Use quantity ' + recommended;
    }
    root.cpCalculate = calculate;
    fields.addEventListener('input', function (event) { if (event.target.name === 'dose') event.target.dataset.cpEdited = '1'; calculate(); });
    fields.addEventListener('change', calculate);
    apply.addEventListener('click', function () {
      if (!result) return;
      var section = root.closest('[data-cp-product]');
      if (!section) return;
      var applied = result.quantity;
      section.querySelectorAll('form.cp-product__form [name="quantity"]').forEach(function (input) {
        var value = normaliseQuantity(applied, input);
        if (value !== null) { input.value = value; input.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      var add = section.querySelector('[data-cp-add-button]'); if (add && !add.disabled) add.focus();
      if (global.CPAnalytics) global.CPAnalytics.track('cp_reorder_quantity_selected', { product: root.dataset.handle, quantity: applied, estimated_four_week_drinks: result.drinks });
    });
    calculate();
  }
  function init(scope) {
    (scope || document).querySelectorAll('[data-cp-consumer-product]').forEach(initMemory);
    (scope || document).querySelectorAll('[data-cp-replenishment]').forEach(initPlanner);
  }
  global.CPProductTools = { init: init, syncVariant: syncVariant, normaliseQuantity: normaliseQuantity };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})(window);
